import { useRef, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { DetailView } from './detail-view';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import PageSection from 'src/layouts/page-section';
import { nextNavigate } from 'src/utils/navigation-utils';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';

const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const router = useRouter();
  const myId = useMemo(() => item.id || 0);

  const subjectClicked = (item) => {
    console.log('====', item);
    let nextLink = paths.tms.details;
    if('repair' === item.title) nextLink = paths.repairs.details;
    if('fuel' === item.title) nextLink = paths.fuels.details;
    
      nextNavigate(
        router,
        {},
        nextLink,
        paths.tickets.index,
        {id: item.id},
      );
    };

  return (
    <PageSection title="Ticket" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.tickets)}
          subLabel={myId}
        />
        <DetailView item={item} subjectClicked={subjectClicked} />
      </Stack>
    </PageSection>
  );
};

export default Page;
